import {Component, Input} from '@angular/core';

@Component({
  selector: 'lib-raoul-component',
  templateUrl: './raoul-component.component.html',
  styleUrls: ['./raoul-component.component.scss']
})
export class RaoulComponent {

  @Input() nom: string;


}
